import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const EventService = {
    getEventById: (id) => {
        return http.get(`${baseUrl}/cliami/events/${id}`);
    },

    getEvents: () => {
        return http.get(`${baseUrl}/cliami/events`);
    },

    saveEvent: (event, eventId) => {
        if (!eventId) {
            return http.post(`${baseUrl}/cliami/events/create`, event);
        } else {
            console.log('edit');
            return http.put(`${baseUrl}/cliami/events/update/${eventId}`, event);
        }
    },

    createSubscription: (eventId, fonctionId) => {
        return http.post(`${baseUrl}/cliami/subscribers/create`, {
            eventId,
            fonctionId,
        });
    },

    deleteSubscription: (subscriberId) => {
        return http.delete(`${baseUrl}/cliami/subscribers/delete/${subscriberId}`);
    },

    deleteEvent: (event) => {
        return http.delete(`${baseUrl}/cliami/events/delete/${event.eventId}`);
    },
};

export default EventService;
